import { render, staticRenderFns } from "./#error.vue?vue&type=template&id=5f1d2799&scoped=true&"
import script from "./#error.vue?vue&type=script&lang=js&"
export * from "./#error.vue?vue&type=script&lang=js&"
import style0 from "./#error.vue?vue&type=style&index=0&id=5f1d2799&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d2799",
  null
  
)

export default component.exports